import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { PetService } from '../../../services/pet.service';

declare var $: any;

@Component({
  selector: 'ngx-vital-sign',
  templateUrl: './vital-sign.component.html', 
})
export class VitalSignComponent implements OnInit {

  
  private _pet_no: number; 
  vital = true;
  dental = false; 
  proc = false;


  @Input() set pet_no(value: number) {
    this._pet_no = value;
    // this.petService.getPetCheckIn(this.petService.current_pet_no).then(() => { });
  }

  get pet_no(): number {
    return this._pet_no;
  }

  constructor(
    public petService: PetService,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit() {
    this.petService.changePet
      .subscribe(message => {
        if (message !== this.pet_no) {
          this.pet_no = message;
        }
      });
  }

  ver(tipo: string) { 
    this.vital = tipo === 'vital'
    this.dental = tipo === 'dental'
    this.proc = tipo === 'proc'
  }

}
